document.addEventListener('DOMContentLoaded', function(){
  
  let formSelector = '#contactForm';
  let contactElems = {
    'nome': {'required': true},
    'cognome': {'required': true},
    'email': {'required': true},
    'oggetto': {'required': true, 'callback': function(){
      $(this).select2({
        placeholder: '-1',
        width: "100%",
        minimumResultsForSearch: -1
      });
    }},
    'telefono': {'required': true},
    'messaggio': {'required': true},
    'cPrivacy': {'required': true},
    'cPrivacyNewsletter': {'required': false},
    'cOtpStat': {'required': false},
    'cOtpProfiling': {'required': false}
  };

  contactForm = new FormController(formSelector, contactElems, document.querySelector("#sendMail"), "https://contacts.moma.it/"+localeForm+"/mail.mngr");
  //contactForm = new FormController(formSelector, contactElems, document.querySelector("#sendMail"), "https://scdn.moma.it/salesforce/mailmgr.php",
})
